// Card image export: drawn on the learner's own device. Nothing is uploaded and no link is created; the
// image leaves only as a file download or through the device's own share menu.
const W = 1080, H = 1350;
const CALL_COL = { LONG: "#22C55E", SHORT: "#EF4444", "NO TRADE": "#60A5FA" };

function wrap(ctx, text, x, y, maxW, lh, maxLines) {
  const words = String(text || "").split(/\s+/);
  let line = "", lines = 0;
  for (let i = 0; i < words.length; i++) {
    const test = line ? `${line} ${words[i]}` : words[i];
    if (ctx.measureText(test).width > maxW && line) {
      if (lines === maxLines - 1) { ctx.fillText(`${line}…`, x, y); return y + lh; }
      ctx.fillText(line, x, y); y += lh; lines++; line = words[i];
    } else line = test;
  }
  if (line) { ctx.fillText(line, x, y); y += lh; }
  return y;
}

export function drawCard(card) {
  const cv = document.createElement("canvas");
  cv.width = W; cv.height = H;
  const ctx = cv.getContext("2d");
  ctx.fillStyle = "#0A0E16"; ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = "#F59E0B"; ctx.font = "600 30px monospace";
  ctx.fillText(card.pack ? `CALL CARD · ${card.pack.name.toUpperCase()}` : "CALL CARD · TRADECRAFT", 64, 96);
  ctx.fillStyle = "#F8FAFC"; ctx.font = "bold 54px sans-serif";
  let y = wrap(ctx, card.title, 64, 170, W - 128, 62, 2);
  ctx.fillStyle = "#94A3B8"; ctx.font = "30px sans-serif";
  y = wrap(ctx, `${card.instrument} · ${card.date_window}`, 64, y + 6, W - 128, 40, 2);
  // chart (decision time)
  const cx = 64, cy = y + 20, cw = W - 128, ch = 430;
  ctx.fillStyle = "#111827"; ctx.fillRect(cx, cy, cw, ch);
  const data = card.chart || [];
  if (data.length) {
    const hi = Math.max(...data.map((c) => c.h)), lo = Math.min(...data.map((c) => c.l));
    const py = (v) => cy + 16 + (ch - 32) * (1 - (v - lo) / ((hi - lo) || 1));
    const step = (cw - 24) / data.length, bw = Math.max(2, step * 0.6);
    data.forEach((c, i) => {
      const x = cx + 12 + i * step + step / 2;
      ctx.strokeStyle = ctx.fillStyle = c.c >= c.o ? "#22C55E" : "#EF4444";
      ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(x, py(c.h)); ctx.lineTo(x, py(c.l)); ctx.stroke();
      ctx.fillRect(x - bw / 2, py(Math.max(c.o, c.c)), bw, Math.max(2, Math.abs(py(c.o) - py(c.c))));
    });
  }
  ctx.fillStyle = "#94A3B8"; ctx.font = "24px monospace"; ctx.fillText("Chart at the moment of the call", cx, cy - 10);
  y = cy + ch + 70;
  // call + outcome
  ctx.fillStyle = "#94A3B8"; ctx.font = "600 26px monospace"; ctx.fillText("MY CALL", 64, y); ctx.fillText("GRADED OUTCOME", 560, y);
  ctx.fillStyle = CALL_COL[card.call] || "#F8FAFC"; ctx.font = "bold 64px sans-serif"; ctx.fillText(card.call, 64, y + 72);
  ctx.fillStyle = "#F8FAFC"; ctx.font = "bold 34px sans-serif";
  const gy = wrap(ctx, card.grade, 560, y + 56, W - 624, 42, 3);
  y = Math.max(y + 140, gy + 30);
  ctx.fillStyle = "#CBD5E1"; ctx.font = "italic 30px sans-serif";
  y = wrap(ctx, `“${card.rationale}”`, 64, y, W - 128, 40, 4);
  ctx.fillStyle = "#94A3B8"; ctx.font = "26px sans-serif";
  y = wrap(ctx, card.verdict, 64, y + 14, W - 128, 34, 2);
  ctx.fillStyle = "#F59E0B"; ctx.font = "600 26px monospace";
  const gains = (card.skill_gains || []).slice(0, 3).map((g) => `${g.label} +${g.delta}`).join(" · ");
  wrap(ctx, `+${card.xp} XP${gains ? ` · ${gains}` : ""} · earned ${new Date(card.earned_at).toLocaleDateString()}`, 64, y + 20, W - 128, 34, 2);
  ctx.fillStyle = "#64748B"; ctx.font = "22px sans-serif";
  wrap(ctx, "Training record of a decision and its graded reasoning. Grades measure process, not profit. Not financial advice.",
    64, H - 70, W - 128, 30, 2);
  return cv;
}

const toBlob = (cv) => new Promise((res) => cv.toBlob(res, "image/png"));
const fileName = (card) => `call-card-${(card.title || "card").toLowerCase().replace(/[^a-z0-9]+/g, "-").slice(0, 40)}.png`;

export async function downloadCard(card) {
  const blob = await toBlob(drawCard(card));
  const url = URL.createObjectURL(blob);  // local object URL on this device only
  const a = document.createElement("a");
  a.href = url; a.download = fileName(card); document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export function canShareFiles() {
  try {
    return !!(navigator.canShare && navigator.canShare({ files: [new File([""], "x.png", { type: "image/png" })] }));
  } catch { return false; }
}

export async function shareCard(card) {
  const blob = await toBlob(drawCard(card));
  const file = new File([blob], fileName(card), { type: "image/png" });
  await navigator.share({ files: [file], title: "My Call Card" });
}
